module.exports = __webpack_public_path__ + "img/theme-dark.4e7217e2.png";